import { AxiosResponse } from "axios"
import { apiUrl } from "../helpers/constants/config.constants"
import { httpGet, httpPatch, httpPost } from "./http.service"

export type InvoiceStatus = 'draft' | 'pending' | 'paid' | 'overdue' | 'cancelled';
export type PaymentMethod = 'cash' | 'credit' | 'debit' | 'ewallet' | 'bank_transfer' | 'voucher' | 'point' | 'other';

export interface Invoice {
  invoiceId: string;
  projectId: string;
  invoiceNumber: string;
  customerId: string;
  sourceId?: string;
  sourceType?: 'booking' | 'order';
  subtotal: number;
  tax: number;
  discount: number;
  total: number;
  currency: string;
  status: InvoiceStatus;
  paymentMethod?: PaymentMethod;
  paymentStatus: string;
  dueDate?: Date;
  paidDate?: Date;
  notes?: string;
  billingAddress?: string;
  billingEmail?: string;
  billingPhone?: string;
  metadata?: Record<string, unknown>;
  createdBy: string;
  createdAt: Date;
  updatedBy?: string;
  updatedAt: Date;
  shortUrl: string;
}

export const doGetInvoice = (invoiceId: string) => {
  return new Promise((resolve, reject) => {
    httpGet(apiUrl.invoice.get(invoiceId)).then((res) => {
      resolve(res)
    }).catch((error) => {
      reject(error)
    })
  })
}

export const doGetInvoiceBySourceId = (sourceId: string) => {
  return new Promise((resolve, reject) => {
    httpGet(apiUrl.invoice.getBySourceId(sourceId)).then((res) => {
      resolve(res)
    }).catch((error) => {
      reject(error)
    })
  })
}

export const doCreateInvoice = (params: Record<string, unknown>) => {
  return new Promise((resolve, reject) => {
    httpPost(apiUrl.invoice.create, { ...params }).then((res) => {
      const response = res as AxiosResponse
      resolve(response)
    }).catch((error) => {
      reject(error);
    })
  });
}

export const doUpdateInvoice = (invoiceId: string, params: Record<string, unknown>) => {
  return new Promise((resolve, reject) => {
    httpPatch(apiUrl.invoice.update(invoiceId), { ...params }).then((res) => {
      const response = res as AxiosResponse
      resolve(response)
    }).catch((error) => {
      reject(error)
    })
  })
}